import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import EmploymentForm from './EmployForm';

const Breadcrumb = ({path=null}) => {
  const location = useLocation();

  // نگاشت مسیرها به نام‌های خوانا
  const routeNames = {
    about: 'درباره ما',
    'contact-us': 'تماس با ما',
    contact:'ثبت شکایت',
    search: 'جستجو',
    products: 'محصولات',
    employmentform: 'فرم استخدام'
  };
  let pathnames = [];
  if(path==null){
    // تبدیل مسیر فعلی به آرایه
    pathnames = location.pathname.split('/').filter((x) => x).map((x) => ({
      link: `/${x}`,
      name:  routeNames[x] || x, // نام پیش‌فرض همان نام بخش مسیر است
    }));
  }
  else{
    pathnames = path;
  }

  return (
    <nav className='breadcrumb-section container' aria-label="breadcrumb-1">
      <ul className='breadcrumb'>
        <li className='breadcrumbItem'>
          <Link to="/" className='breadcrumb-link'>
            خانه
          </Link>
          {pathnames.length > 0 && <span className='breadcrumb-seperator'>/</span>}
        </li>

        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1;

          return (
            <li key={value.link} className='breadcrumbItem'>
              {isLast ? (
                <span className='breadcrumb-current'>{decodeURIComponent(value.name)}</span>
              ) : (
                <>
                  <Link to={value.link} className='breadcrumb-link'>
                    {decodeURIComponent(value.name)}
                  </Link>
                  <span className='breadcrumb-seperator'>/</span>
                </>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
